// extracted by mini-css-extract-plugin
export default {"legalPage":"LegalPage_legalPage__fLozh","content":"LegalPage_content__w5XH7"};